import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'


export default function MeasureWeightsBasicInfoComponent ({handleInnerFormChange, selectMeasureWeights}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         
          <InputContainer

                  label="Name"
                  name="Name"
                  onValueChange={(event: any) => {
                    handleInnerFormChange(
                      event.target.value,
                       'Name',

                         )
                       }}
                   type="text"
                   value={selectMeasureWeights?.Name}
                />
                   <InputContainer

                    label="SystemKeyword"
                    name="SystemKeyword"
                    onValueChange={(event: any) => {
                     handleInnerFormChange(
                     event.target.value,
                    'SystemKeyword',

                             )
                             }}
                     type="text"
                    value={selectMeasureWeights?.SystemKeyword}
                        />
                        <InputContainer

                            label="Ratio"
                            name="Ratio"
                            onValueChange={(event: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'Ratio',

                             )
                                }}
                            type="number"
                        value={selectMeasureWeights?.Ratio}
                        />
                            <InputContainer

                                label="PrimaryWeight"
                                name="IsPrimaryWeight"
                                onValueChange={(event: any) => {
                             handleInnerFormChange(
                                 event,
                                'IsPrimaryWeight',

                              )
                     }}
                type="checkbox"
                 value={selectMeasureWeights?.IsPrimaryWeight}
                />
            <InputContainer
              label="DisplayOrder"
              name="DisplayOrder"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DisplayOrder',

                )
              }}
              type="number"
              value={selectMeasureWeights?.DisplayOrder}
          />
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}